import { createFileRoute } from '@tanstack/react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { Footer, HeaderMiddle, Navbar, TopBar } from '../components/SiteChrome'
import { WhatsAppChannelSection } from '../components/WhatsAppChannelSection'
import { getStorefrontConfig } from '../lib/dropify'
import { DEFAULT_OG_IMAGE, absoluteUrl } from '../lib/seo'

export const Route = createFileRoute('/tentang-kami')({
  loader: async () => ({
    config: await getStorefrontConfig().catch(() => null),
  }),
  head: () => ({
    meta: [
      { title: 'Tentang Kami – Distributor Grosir Tangan Pertama | Dropify' },
      { name: 'description', content: 'Mengenal Dropify, distributor tangan pertama untuk pembeli grosir Indonesia.' },
      { property: 'og:title', content: 'Tentang Kami – Distributor Grosir Tangan Pertama | Dropify' },
      { property: 'og:description', content: 'Mengenal Dropify, distributor tangan pertama untuk pembeli grosir Indonesia.' },
      { property: 'og:url', content: absoluteUrl('/tentang-kami') },
      { property: 'og:image', content: DEFAULT_OG_IMAGE },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Tentang Kami – Distributor Grosir Tangan Pertama | Dropify' },
      { name: 'twitter:description', content: 'Mengenal Dropify, distributor tangan pertama untuk pembeli grosir Indonesia.' },
      { name: 'twitter:image', content: DEFAULT_OG_IMAGE },
    ],
    links: [
      { rel: 'canonical', href: absoluteUrl('/tentang-kami') },
    ],
  }),
  component: TentangKamiPage,
})

function TentangKamiPage() {
  const { config } = Route.useLoaderData()

  return (
    <div className="min-h-screen bg-slate-50">
      <TopBar config={config} />
      <HeaderMiddle />
      <Navbar />

      <div className="bg-slate-900 py-14">
        <div className="max-w-7xl mx-auto px-4">
          <nav className="flex items-center gap-1.5 text-xs text-slate-400 mb-4">
            <a href="/" className="hover:text-white transition-colors">Beranda</a>
            <FontAwesomeIcon icon={faChevronRight} className="w-3 h-3" />
            <span className="text-white font-medium">Tentang Kami</span>
          </nav>
          <h1 className="text-4xl font-black text-white uppercase tracking-tight mb-2">Tentang Kami</h1>
          <p className="text-slate-300 text-sm max-w-2xl">
            Dropify adalah distributor di Surabaya yang melayani pemesanan grosir melalui WhatsApp dan mengirim ke berbagai kota di Indonesia.
          </p>
        </div>
      </div>

      <WhatsAppChannelSection />

      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl border border-slate-100 p-8 md:p-10 space-y-8">
          <section>
            <h2 className="text-xl font-black text-slate-900 uppercase tracking-tight mb-3">Siapa Kami</h2>
            <p className="text-sm text-slate-600 leading-relaxed">
              Dropify melayani pembelian grosir pakaian dalam, kaos kaki, handuk, sarung tangan, dan kategori kebutuhan harian lain. Pembeli memilih produk dari katalog, lalu mengirim kode produk, jumlah, varian, dan kota tujuan kepada admin.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-slate-900 uppercase tracking-tight mb-3">Visi Kami</h2>
            <p className="text-sm text-slate-600 leading-relaxed">
              Menjadi pemasok grosir yang dapat dinilai dari kejelasan produk, ketepatan quotation, dan proses pemenuhan pesanan.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-slate-900 uppercase tracking-tight mb-3">Misi Kami</h2>
            <p className="text-sm text-slate-600 leading-relaxed">
              Kami ingin membantu toko, reseller, dan tim pengadaan memilih produk, memahami satuan serta MOQ, lalu menyelesaikan pemesanan melalui satu percakapan WhatsApp.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-slate-900 uppercase tracking-tight mb-3">Cara Kami Bekerja</h2>
            <ul className="space-y-3 text-sm text-slate-600 leading-relaxed">
              <li>Produk ditampilkan dengan kode, kategori, foto, dan rincian yang tersedia.</li>
              <li>Admin memeriksa varian, jumlah, stok, serta ongkir sebelum mengirim quotation.</li>
              <li>Rincian barang dan tujuan pengiriman dikonfirmasi sebelum penyiapan. Waktu transfer mengikuti alur pembayaran yang disepakati.</li>
            </ul>
          </section>
        </div>
      </main>

      <Footer config={config} />
    </div>
  )
}
